export const ADDITIONAL_REQUESTS = 'additionalRequests';
export const ACTIVITY_ITEMS = 'activityItems';
export const PREAWARD_COSTS = 'preAwardCosts';
export const PREVIOUS_REQUEST_DETAILS = 'previousRequestDetails';
export const FUNDING_STREAMS = 'fundingStreams';
export const YEAR = 'year';
export const QUANTITY = 'quantity';
export const PRICE = 'price';
export const ACTUAL_QUANTITY = 'actualQuantity';
export const ACTUAL_PRICE = 'actualPrice';
export const ACTUAL_UNIT_OF_MEASURE = 'actualUnitOfMeasure';
export const NUMBER_OF_YEARS = 'numberOfYears';
export const BOC = 'boc';
export const COST_CLASSIFICATION = 'costClassification';
export const UNIT_OF_MEASURE = 'unitOfMeasure';
export const PRE_AWARD = 'preAward';
export const PHASED_PROJECT = 'phasedProject';
export const DESCRIPTION = 'description';
export const EXPLAIN_OTHER_ITEM = 'explainOtherItem';
export const NAME = 'name';
export const COMMENTS = 'comments';
export const ADDITIONAL_INFORMATION = 'additionalInformation';
export const EXPLAIN_OTHER = `${ADDITIONAL_INFORMATION}.explainOtherItem`;
export const PERFORMING_ORG_ID_PATH = `${ADDITIONAL_INFORMATION}.orgIdPerformingWork`;
export const ANNUAL_SALARY = 'annualSalary';
export const ANNUAL_BENEFITS = 'annualBenefits';
export const TOTAL_ELIGIBLE_COST = 'totalCost';
export const PAYMENT = 'payment';
export const PAYMENT_PATH_ROOT = [ADDITIONAL_INFORMATION, PAYMENT];
export const PERSONNEL = 'personnel';
export const FRINGE_BENEFITS = 'fringeBenefits';
export const COST = 'cost';
export const TOTAL = 'total';
export const ACTUAL_TOTAL = 'actualTotal';
export const ACTUAL_ALLOWED_TOTAL = 'actualAllowedTotal';
export const SCOPE_OF_WORK_TOTAL = 'scopeOfWorkTotal';
export const ALLOWED_EXCESS_TOTAL = 'allowedExcessTotal';
export const DISALLOWED_TOTAL = 'disallowedTotal';
export const CATEGORIZED_SUM = 'categorizedSum';
export const NOT_FULLY_IN_SCOPE = 'notFullyInScope';
export const OPSG = 'OPSG';
export const SHSP = 'SHSP';
export const UASI = 'UASI';
export const SHSPFOROPSG = 'SHSPForOPSG';
export const SHSPFORSHSP = 'SHSPForSHSP';
export const UASIFORUASI = 'UASIForUASI';
export const OPSGFOROPSG = 'OPSGForOPSG';
export const FED_SHARE_AWARD_COST_NON_MA_AND_MA = 'fedShareAwardCost'; // fed share of grand total
export const TOT_AWARD_COST_NON_MA_AND_MA = 'totalNonMaCost'; // Grant Total
export const FED_SHARE_COST_NON_MA_AND_MA = 'fedSharenonMACost'; // fed share of non M&A funding stream
export const TOT_AWARD_COST = 'totalAwardCost'; // total non-M&A funding stream
export const TOT_PROJECT_COST = 'totalProjectCosts'; // total non-M&A funding stream
export const LOCAL_AGENCY = 'Local Agency';
export const STATE_AGENCY = 'State Agency';
export const OBLIGATION_DOC_STATUS_CLOSED = '92';
export const ENTITY_TYPE_SUBGRANT = 'subGrant';

export const CHANGES_TYPES = {
  VALUE_CHANGE: 'valueChange',
  INELIGIBLE_CHANGE: 'ineligibleChange',
  NEWLY_CREATED: 'newlyCreated',
  VALUE_CHANGE_NO_DISPLAY: 'valueChangeNoDisplay',
  DEFERRED_CHANGE: 'deferredChange',
};

export const MODES = {
  CLOSEOUT_REPORT: 'closeoutReport',
  CLOSEOUT_REPORT_REVIEW: 'closeoutReportReview',
  REVIEW: 'review',
  PAYMENT_REQUEST: 'paymentRequest',
  APPLICATION: 'application',
  CLOSEOUT_RECONCILIATION: 'closeoutReconciliation',
  CLOSEOUT_RECON_DEOB: 'closeoutReconciliationDeob',
};

export const MODE_NAMES = {
  [MODES.CLOSEOUT_REPORT]: 'Award Costs',
  [MODES.CLOSEOUT_REPORT_REVIEW]: 'Award Costs',
  [MODES.REVIEW]: 'Request Details',
  [MODES.APPLICATION]: 'Grant request details',
  [MODES.PAYMENT_REQUEST]: 'Budget Items',
};

export const CARD_TYPES = {
  SIMPLE: 'simple',
  BUDGETLINEITEM: 'BudgetLineItem',
  STAFFING_BUNDLED: 'staffingBundled',
  SIMPLE_HIRING: 'simpleHiring',
};

export const NO_DIFF_FIELDS = ['description', 'costexplain'];

export const DEFAULT_CONFIG = {
  items: undefined,
  maxOccurs: undefined,
  children: undefined,
  name: undefined,
};

export const COST_ITEM_PERIOD_TYPE = {
  WHOLE: 'whole',
  YEAR: 'year',
};

export const VALUE_CHANGE_FORMAT = {
  description: 'text',
  price: 'dollar',
  quantity: 'text',
  item: 'text',
  boc: 'text',
  costClassification: 'text',
  preAward: 'boolean',
  amount: 'dollar',
  costexplain: 'text',
  annualSalary: 'dollar',
  annualBenefits: 'dollar',
  fullTimePosition: 'text',
};

export const VALUE_CHANGE_DISPLAY = {
  description: 'Description',
  price: 'Unit price',
  quantity: 'Quantity',
  item: 'Item',
  itemCode: 'Item',
  boc: 'Budget class',
  costClassification: 'Cost classification',
  unitOfMeasure: 'Unit of measure',
  preAward: 'Pre-award',
  amount: 'Amount',
  costexplain: 'Benefits funded',
  annualSalary: 'Annual salary',
  annualBenefits: 'Annual benefits',
  phasedProject: 'Project phase',
  actualTotal: 'Total costs',
};

export const FUNDING_STREAM_NAME = {
  preAwardCosts: 'Pre-Award Costs',
  hiringOfFirefighters: 'Hiring of firefighters',
  recruitmentAndRetention: 'Recruitment and retention',
  firePreventionAndSafety: 'Fire prevention and safety',
  researchAndDevelopment: 'Research and development',
  plan: 'Plan',
  project: 'Project',
  operationsAndSafety: 'Operations and safety',
  vehicleAcquisition: 'Vehicle acquisition',
  nonConstruction: 'Non construction',
  construction: 'Construction',
  disasterCaseManagement: 'Disaster Case Management',
  managementCosts: 'Management costs',
  investment: 'Investment',
  indirectExpenses: 'Indirect expenses',
  emergencyProtectiveMeasures: 'Emergency protective measures',
  fireFightingActivities: 'Fire-fighting activities',
  fireSuppressionActivities: 'Fire suppression activities',
  administrativeCosts: 'Administrative costs',
  donatedResources: 'Donated resources',
};

export const BOC_NAMES = {
  equipment: 'Equipment',
  construction: 'Construction',
  contractual: 'Contractual',
  fringeBenefits: 'Fringe benefits',
  indirectCharges: 'Indirect charges',
  other: 'Other',
  personnel: 'Personnel',
  supplies: 'Supplies',
  travel: 'Travel',
  indirectExpenses: 'Indirect expenses',
};

export const BOCS = [
  'equipment',
  'construction',
  'contractual',
  'fringeBenefits',
  'indirectCharges',
  'other',
  'personnel',
  'supplies',
  'travel',
];

export const SUBPROGRAMS = ['OPSG', 'SHSP', 'UASI'];

export const FUNDING_STREAM_CODES = {
  PROJECT_COST: {
    code: 418,
    label: 'Project Cost',
  },
  MANAGEMENT_COST: {
    code: 419,
    label: 'Management Cost',
  },
};

export const FIELD_MAX_LENGTHS_SYSTEM = {
  [CARD_TYPES.STAFFING_BUNDLED]: {
    [QUANTITY]: 4,
    [ACTUAL_QUANTITY]: 4,
    [ANNUAL_SALARY]: 10,
    [DESCRIPTION]: 2001,
  },
  [CARD_TYPES.SIMPLE]: {
    [QUANTITY]: 7,
    [ACTUAL_QUANTITY]: 7,
    [PRICE]: 9,
    [ACTUAL_PRICE]: 9,
    [DESCRIPTION]: 2001,
    [EXPLAIN_OTHER]: 101,
  },
  [CARD_TYPES.SIMPLE_HIRING]: {
    [QUANTITY]: 7,
    [ACTUAL_QUANTITY]: 7,
    [PRICE]: 9,
    [ACTUAL_PRICE]: 9,
    [DESCRIPTION]: 2001,
    [EXPLAIN_OTHER]: 101,
    [EXPLAIN_OTHER_ITEM]: 251,
  },
};

export const COMMITMENT_STATE = {
  NEW: 'new',
  EXISTING: 'existing',
};

export const FOID_FOR_COST_TYPE = {
  1029: CARD_TYPES.SIMPLE_HIRING,
  1025: CARD_TYPES.SIMPLE_HIRING,
  1016: CARD_TYPES.SIMPLE_HIRING,
  1012: CARD_TYPES.STAFFING_BUNDLED,
  1007: CARD_TYPES.STAFFING_BUNDLED,
};

export const PROGRAM_STATUS_CODES = {
  APPROVED: 'approved',
  DRAFT: 'draft',
};

export const DRAFT_FO_STATUS_CODES = {
  APPROVED: 'approved',
  DRAFT: 'draft',
};

export const FUNDING_STREAM_TYPES = {
  MANAGEMENT_COSTS: 'managementCosts',
  CONSTRUCTION_COSTS: 'construction',
  INDIRECT_COSTS: 'indirectExpenses',
};
